<template>
  <view v-if="info" class="detail" :style="{ paddingTop: paddingTop }">
    <view class="u-flex-c">
      <view v-if="info.auctionType === 'BLIND'" class="blind H6">暗拍</view>

      <view class="name H3 otext2">{{ info.fieldName }}</view>
    </view>
    <view class="state">
      <view class="u-flex-c shrink-0">
        <text class="N5">{{ info.auctionCount }}</text>
        <text class="H6">件拍品</text>
      </view>
      <DuDivider type="vertical" length="11px" />
      <view class="time before">
        <SessionTime
          :today="new Date().getTime()"
          :item="{
            startTime: +info.startTime,
            earliest: info.earliestAt * 1000,
          }"
        />
      </view>
    </view>
    <view class="description B6" v-if="info.description">
      <span>{{ info.description }}</span>
    </view>
    <!-- 拍场关联的热点：接口已按关联时间倒序并过滤下架/失效热点 -->
    <view v-if="info.hotspots?.length" class="hotspots">
      <view
        v-for="hotspot in info.hotspots"
        :key="hotspot.id"
        class="hotspot"
        @click="handleGotoHotspot(hotspot)"
      >
        <img
          class="hotspot-label"
          :src="hotspotLabelImage"
          alt="热点"
        />
        <text class="hotspot-name">{{ hotspot.name }}</text>
      </view>
    </view>
    <view v-if="info?.listPermissionType === 'WL_INTERNAL_GROUP'">
      <view class="wl_internal_group B7">
        <DuIcon name="people" size='3.2rem' />
        <view>本拍场仅限指定用户可发布拍品</view>
      </view>
    </view>
  </view>
</template>

<script setup>
import { defineProps } from "vue";
import dayjs from "dayjs";
dayjs.locale("zh-cn");
import { DuIcon, DuDivider } from "dangoui";
import SessionTime from "./session-time.vue";
import { useRouter } from "vue-router";
import jb from "@frontend/effuse";
import { isLinjieApp } from "@/utils/env-related";
import hotspotLabelImage from "@/assets/hotspot-label.png";

import { computed } from "vue";
defineProps({
  info: {
    type: Object,
    default: () => null,
  },
});
const router = useRouter();

function handleGotoHotspot(hotspot) {
  if (!hotspot?.id) {
    return;
  }
  if (isLinjieApp()) {
    jb.navigateTo({ url: `congress://hotspot?id=${hotspot.id}` });
  } else {
    router.push(`/hotspot?id=${hotspot.id}`);
  }
}
const paddingTop = computed(() => {
  const navHeight = 84;

  return `calc(${navHeight}px + 30rpx)`;
});
</script>

<style lang="scss">
.shrink-0 {
  flex-shrink: 0;
}
.u-flex-c {
  display: flex;
  align-items: center;
}
.detail {
  display: flex;
  flex-direction: column;
  gap: 16rpx;
  width: 570rpx;
  padding: 24rpx 30rpx;
  .name {
    width: 100%;
  }
  .description {
    white-space: pre-wrap;
    color: rgba(0, 0, 0, 0.64);
  }
  .hotspots {
    display: flex;
    gap: 16rpx;
    // .detail 宽度只到插画左侧，标签行需要横向撑到页面右边缘再滑动；
    // 用 rpx 而非 vw：宽屏下页面限宽 480px，750rpx 始终等于页面宽度
    width: 720rpx;
    padding-right: 30rpx;
    box-sizing: border-box;
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
    &::-webkit-scrollbar {
      display: none;
    }
  }
  .hotspot {
    display: flex;
    flex-shrink: 0;
    align-items: center;
    gap: 8rpx;
    height: 56rpx;
    padding: 0 16rpx;
    border-radius: 12rpx;
    background: rgba(255, 255, 255, 0.24);
    white-space: nowrap;
    font-size: 24rpx;
  }
  .hotspot-label {
    display: block;
    flex-shrink: 0;
    width: 48rpx;
    height: 28rpx;
    object-fit: contain;
  }
  .hotspot-name {
    color: rgba(0, 0, 0, 0.88);
  }
  .wl_internal_group {
    gap: 8rpx;
    border-radius: 8rpx;
    padding: 8rpx;
    color: rgba(0, 0, 0, 0.4);
    display: inline-flex;
    align-items: center;
    background: rgba(255, 255, 255, 0.24);
  }
  .blind {
    flex-shrink: 0;
    margin-right: 16rpx;
    padding: 0 6rpx;
    font-size: 22rpx;
    color: #fff;
    border-radius: var(--Radius-Small, 8rpx);
    border: 2rpx solid var(--transBlack-border, rgba(0, 0, 0, 0.24));
    background: var(--transBlack-solidBg, rgba(0, 0, 0, 0.88));
  }
  .state {
    display: flex;
    align-items: center;
    gap: 8rpx;
  }
  .follow-button {
    width: 240rpx;
  }
}
</style>
